var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-widget20"},[_c('div',{staticClass:"kt-widget20__chart",staticStyle:{"height":"330px"}},[_c('Chart1',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }